export interface IProjectionPagedModel<T> {
    Data: Array<T>
    Total: number
}

export class ProjectionPagedModel<T> implements IProjectionPagedModel<T> {
    Data: Array<T>
    Total: number
}
